var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-radio",class:{
    'selectable-input' : _vm.selectableInput,
    'hidden-radio' : _vm.hiddenRadio,
    checked: _vm.value === _vm.radioValue,
  }},[_c('input',{attrs:{"id":_vm.inputId,"type":"radio","name":_vm.radioName},domProps:{"value":_vm.radioValue,"checked":_vm.value === _vm.radioValue}}),_c('label',{attrs:{"for":_vm.inputId},on:{"click":function($event){return _vm.$emit('input', _vm.radioValue)}}},[_c('div',{staticClass:"p-radio-content"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }